export const bronze = '#B69242'
export const yellow = '#FFEE00'
export const grey = '#DBD6D0' 
export const burntRed = '#471E19'
export const brown = '#443515'
export const darkBrown = '#54421b'


